import { render, staticRenderFns } from "./CreateProject.vue?vue&type=template&id=72cf41b6"
import script from "./CreateProject.vue?vue&type=script&lang=js"
export * from "./CreateProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports